import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type {
  GetContentViewsResponse,
  GetDevicesUsedResponse,
  GetProjectCountriesResponse,
  GetSignupsAndSubscriptionsResponse,
} from "@/src/api/StatsAPI.types";
import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

// Shared so identical params hit one cache entry; queries keep the previous period while refetching.

export function signupsAndSubscriptionsQuery(
  projectSlug: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetSignupsAndSubscriptionsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getSignupsAndSubscriptions,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function contentViewsQuery(
  projectSlug: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetContentViewsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getContentViews,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function projectCountriesQuery(
  projectSlug: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetProjectCountriesResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getProjectCountries,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function devicesUsedQuery(
  projectSlug: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetDevicesUsedResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getDevicesUsed,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}
